import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyOrdersComponent } from './Component/my-orders/my-orders.component';
import { OrderDetailComponent } from './Component/order-detail/order-detail.component';
import { OrderSelectionComponent } from './Component/order-selection/order-selection.component';
import { OrdersAvailableCartComponent } from './Component/orders-available-cart/orders-available-cart.component';


const routes: Routes = [
  {
    path: '', component: MyOrdersComponent
  },
  {
    path: 'detail/:orderid', component: OrderDetailComponent
  },
  {
    path: 'order-selection', component: OrderSelectionComponent
  },
  {
    path: 'order-cart/:orderid', component: OrdersAvailableCartComponent
  },


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderRoutingModule { }
